// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Recoil$OrcaPaymentPage from "../libraries/Recoil.bs.js";
import * as GiftCardTypes$OrcaPaymentPage from "../Types/GiftCardTypes.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";

var paymentManagementList = Recoil$OrcaPaymentPage.atom("paymentManagementList", "LoadingV2");

var showAddScreen = Recoil$OrcaPaymentPage.atom("showAddScreen", false);

var vaultMode = Recoil$OrcaPaymentPage.atom("vaultMode", "None");

var managePaymentMethod = Recoil$OrcaPaymentPage.atom("managePaymentMethod", "");

var savedMethodsV2 = Recoil$OrcaPaymentPage.atom("savedMethodsV2", [UnifiedHelpersV2$OrcaPaymentPage.defaultCustomerMethods]);

var paymentMethodsListV2 = Recoil$OrcaPaymentPage.atom("paymentMethodsListV2", "LoadingV2");

var intentList = Recoil$OrcaPaymentPage.atom("intentList", "LoadingIntent");

var paymentMethodListValueV2 = Recoil$OrcaPaymentPage.atom("paymentMethodListValueV2", UnifiedHelpersV2$OrcaPaymentPage.defaultPaymentsList);

var vaultPublishableKey = Recoil$OrcaPaymentPage.atom("vaultPublishableKey", "");

var vaultProfileId = Recoil$OrcaPaymentPage.atom("vaultProfileId", "");

var giftCardInfoAtom = Recoil$OrcaPaymentPage.atom("giftCardInfo", GiftCardTypes$OrcaPaymentPage.defaultGiftCardInfo);

var areSplitPaymentRequiredFieldsValid = Recoil$OrcaPaymentPage.atom("areSplitPaymentRequiredFieldsValid", true);

var areSplitPaymentRequiredFieldsEmpty = Recoil$OrcaPaymentPage.atom("areSplitPaymentRequiredFieldsEmpty", false);

export {
  paymentManagementList ,
  showAddScreen ,
  vaultMode ,
  managePaymentMethod ,
  savedMethodsV2 ,
  paymentMethodsListV2 ,
  intentList ,
  paymentMethodListValueV2 ,
  vaultPublishableKey ,
  vaultProfileId ,
  giftCardInfoAtom ,
  areSplitPaymentRequiredFieldsValid ,
  areSplitPaymentRequiredFieldsEmpty ,
}
/* paymentManagementList Not a pure module */
